import { render, staticRenderFns } from "./HandleEx.vue?vue&type=template&id=0a921289&scoped=true&"
import script from "./HandleEx.vue?vue&type=script&lang=js&"
export * from "./HandleEx.vue?vue&type=script&lang=js&"
import style0 from "./HandleEx.vue?vue&type=style&index=0&id=0a921289&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a921289",
  null
  
)

export default component.exports